/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnerDraftsControllerOwnerQueryResponse, OwnerDraftsControllerOwnerPathParams, OwnerDraftsControllerOwner400, OwnerDraftsControllerOwner401, OwnerDraftsControllerOwner403, OwnerDraftsControllerOwner404 } from "../../models/ownerDraftsController/OwnerDraftsControllerOwner";

function getOwnerDraftsControllerOwnerUrl(id: OwnerDraftsControllerOwnerPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/document-drafts/owner/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/owner/:id}
 */
export async function ownerDraftsControllerOwner(id: OwnerDraftsControllerOwnerPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OwnerDraftsControllerOwnerQueryResponse, ResponseErrorConfig<OwnerDraftsControllerOwner400 | OwnerDraftsControllerOwner401 | OwnerDraftsControllerOwner403 | OwnerDraftsControllerOwner404>, unknown>({ method : "GET", url : getOwnerDraftsControllerOwnerUrl(id).url.toString(), ... requestConfig })  
  return res.data
}